import { type MetaFunction } from 'react-router'
import { siteTitle } from '#app/utils/global.ts'

export const meta: MetaFunction = () => [{ title: siteTitle }]

export default function Index() {
	return (
		<main className="relative h-full sm:flex sm:items-center sm:justify-center">
			<div className="relative sm:pt-8 sm:pb-16">
				<div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
					<h1 className="text-h1 text-center">
						<span className="sr-only">SparkLing Admin</span>
						<img className="w-96" src="/img/logo.png" alt="SparkLing" />
					</h1>
				</div>
			</div>
		</main>
	)
}
